// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/store.js'
import dayjs from 'dayjs'
import empty from 'is-empty'
import axios from 'axios'
import _ from 'lodash'
import 'animate.css'
import 'normalize.css'
import 'fullpage-vue/src/fullpage.css'
import VueFullpage from 'fullpage-vue'
import VueGoogleMap from 'vuejs-google-maps'
import VModal from 'vue-js-modal'
import gaFunc from './ga'
import VueGtag from 'vue-gtag'
import 'vuejs-google-maps/dist/vuejs-google-maps.css'
Vue.use(VueGoogleMap, {
  load: {
    apiKey: 'AIzaSyDfG-TOTtisGaVNWYvz38HPpaJNrO1fqbI',
    libraries: ['places', 'visualization']
  }
})
Vue.use(VueGtag, {
  config: { id: 'UA-110136251-5' }
})
Vue.use(VModal, { dynamic: true })
Vue.use(VueFullpage)
Vue.config.productionTip = false
Vue.prototype.$dayjs = dayjs
Vue.prototype.$empty = empty
Vue.prototype.$gaFunc = gaFunc
Vue.prototype.$axios = axios
Vue.prototype.$_ = _
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js